import { get, getIn } from 'immutable';
import { Licenses } from '@Constants/User';

function getFirstAlphanumericChar(str) {
  const match = str.match(/[a-z0-9]/i);
  return match?.[0]?.toUpperCase() ?? '';
}

export function getFirstLastName(currentUser) {
  const firstName = getIn(currentUser, ['details', 'firstName']);
  const lastName = getIn(currentUser, ['details', 'lastName']);

  return (firstName || lastName) && `${firstName} ${lastName}`;
}

export function getInitials(currentUser) {
  const firstName = getIn(currentUser, ['details', 'firstName']);
  const lastName = getIn(currentUser, ['details', 'lastName']);

  return (firstName || lastName) && `${getFirstAlphanumericChar(firstName)}${getFirstAlphanumericChar(lastName)}`;
}

export function isRMCLicense(currentUser) {
  const license = getIn(currentUser, ['details', 'license']);
  return license && license === Licenses.ReaxysMedChem;
}

export function isAnonymousUser(currentUser) {
  const authType = getIn(currentUser, ['details', 'authType']);
  return authType && authType === 'anonymous';
}

export function isShibbolethUser(currentUser) {
  const authType = getIn(currentUser, ['details', 'authType']);
  return authType && authType === 'institution-sso';
}

export function isAnonShibbolethLogin(currentUser) {
  const accessType = getIn(currentUser, ['details', 'loginDetails', 'accessType'], '');
  return accessType.indexOf('ANON_SHIBBOLETH:SHIBBOLETH') !== -1;
}

export function userHasRegistration(currentUser) {
  const permissions = get(currentUser, 'permissions', []);
  return permissions.indexOf('REGISTRATION_PAGE_ONLY') !== -1;
}

export function userHasInstitutionLogin(currentUser) {
  const permissions = get(currentUser, 'permissions', []);
  return permissions.length ? permissions.indexOf('INSTITUTION_SHIBBOLETH_LOGIN') !== -1 : true;
}
